module.exports = __webpack_public_path__ + "img/luxembourg.f2ab0eaa.svg";